// Componente snackbar tipo material para notificaciones
// Uso: window.showSnackbar(message, type)
// type: 'success' | 'error' | 'info'

const snackbar = document.createElement("div");
snackbar.id = "snackbar";
snackbar.className =
  "fixed bottom-6 left-1/2 -translate-x-1/2 z-50 px-6 py-3 rounded-lg shadow-lg text-white text-base font-medium flex items-center gap-2 opacity-0 pointer-events-none transition-all duration-300";
document.body.appendChild(snackbar);

const typeStyles = {
  success: "bg-green-600",
  error: "bg-red-600",
  info: "bg-gray-800",
};

window.showSnackbar = function (message, type = "info") {
  snackbar.textContent = message;
  snackbar.className = `fixed bottom-6 left-1/2 -translate-x-1/2 z-50 px-6 py-3 rounded-lg shadow-lg text-white text-base font-medium flex items-center gap-2 opacity-0 pointer-events-none transition-all duration-300 ${
    typeStyles[type] || typeStyles.info
  }`;
  setTimeout(() => {
    snackbar.classList.remove("opacity-0", "pointer-events-none");
    snackbar.classList.add("opacity-100");
  }, 10);
  setTimeout(() => {
    snackbar.classList.remove("opacity-100");
    snackbar.classList.add("opacity-0", "pointer-events-none");
  }, 3000);
};
